import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'highlight',
  standalone: true
})
export class HighlightPipe implements PipeTransform {
  transform(value: string, search: string): string {
    if (!search) {
      return value;
    }

    const searchRegex = search.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const regex = new RegExp(searchRegex, 'gi');

    return value.replace(regex, match => `<b class="font-bold">${match}</b>`);
  }
}
